webpackJsonp([104430055873717],{

/***/ 43:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portfolios = function (_React$Component) {
	  _inherits(Portfolios, _React$Component);
	
	  function Portfolios() {
	    _classCallCheck(this, Portfolios);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Portfolios.prototype.componentDidMount = function componentDidMount() {
	    var isBrowser = typeof window !== 'undefined';
	    var AOS = isBrowser ? __webpack_require__(3) : undefined;
	    this.aos = AOS;
	    this.aos.init();
	  };
	
	  Portfolios.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.aos.refresh();
	  };
	
	  Portfolios.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { className: 'portfolio-cards-container' },
	      _react2.default.createElement('img', { alt: 'Portfolio trend graph', src: (0, _gatsbyLink.withPrefix)('images/graphics/portfolio-trend.svg'), className: 'portfolio-trend-image' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-portfolio defensive' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'card-title' },
	              'Defensive'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Lower risk, Lower return'
	              ),
	              _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'card-caption' },
	                  'Allocation:'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'progress' },
	                  _react2.default.createElement('div', { className: 'progress-bar bg-shares--light w-35', role: 'progressbar', 'aria-valuenow': '35', 'aria-valuemin': '0', 'aria-valuemax': '100' }),
	                  _react2.default.createElement('div', { className: 'progress-bar bg-bonds w-65', role: 'progressbar', 'aria-valuenow': '65', 'aria-valuemin': '0', 'aria-valuemax': '100' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'allocation-block d-flex justify-content-around' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shares-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '35%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Shares'
	                  )
	                ),
	                _react2.default.createElement('span', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bonds-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '65%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Bonds'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'badge badge-light' },
	                'Core'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-portfolio balanced' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'card-title' },
	              'Balanced'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Medium risk, Medium return'
	              ),
	              _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'card-caption' },
	                  'Allocation:'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'progress' },
	                  _react2.default.createElement('div', { className: 'progress-bar bg-shares w-60', role: 'progressbar', 'aria-valuenow': '60', 'aria-valuemin': '0', 'aria-valuemax': '100' }),
	                  _react2.default.createElement('div', { className: 'progress-bar bg-bonds w-40', role: 'progressbar', 'aria-valuenow': '40', 'aria-valuemin': '0', 'aria-valuemax': '100' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'allocation-block d-flex justify-content-around' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shares-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '60%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Shares'
	                  )
	                ),
	                _react2.default.createElement('span', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bonds-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '40%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Bonds'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'badge badge-light' },
	                'Core'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6 col-md-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-portfolio growth' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'card-title' },
	              'Growth'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'High risk, Higher return'
	              ),
	              _react2.default.createElement(
	                'section',
	                null,
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'card-caption' },
	                  'Allocation:'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'progress' },
	                  _react2.default.createElement('div', { className: 'progress-bar bg-shares w-95', role: 'progressbar', 'aria-valuenow': '35', 'aria-valuemin': '0', 'aria-valuemax': '95' }),
	                  _react2.default.createElement('div', { className: 'progress-bar bg-bonds--light w-5', role: 'progressbar', 'aria-valuenow': '5', 'aria-valuemin': '0', 'aria-valuemax': '100' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'allocation-block d-flex justify-content-around' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'shares-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '95%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Shares'
	                  )
	                ),
	                _react2.default.createElement('span', { className: 'divider' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bonds-percentage' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '5%'
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Bonds'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'badge badge-light' },
	                'Core'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Portfolios;
	}(_react2.default.Component);
	
	exports.default = Portfolios;
	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Themes = function (_React$Component) {
	  _inherits(Themes, _React$Component);
	
	  function Themes(props) {
	    _classCallCheck(this, Themes);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  //==============
	  // React Methods
	  //==============
	
	  Themes.prototype.componentDidMount = function componentDidMount() {
	    var isBrowser = typeof window !== 'undefined';
	    var AOS = isBrowser ? __webpack_require__(3) : undefined;
	    this.aos = AOS;
	    this.aos.init();
	  };
	
	  Themes.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.aos.refresh();
	  };
	
	  //=================
	  // Render Component
	  //=================
	
	  Themes.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { className: 'theme-cards-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-theme' },
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/themes/technology.jpg'), className: 'card-img-top', alt: 'Technology theme image' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Technology'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Invest your money towards the brands you rely on everyday. Add the most innovative companies to your portfolio including Apple, Facebook, Amazon and Google.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between align-items-center' },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'cta-link', href: 'http://www.betashares.com.au/fund/nasdaq-100-etf/#each-overview', target: '_blank' },
	                  'Learn more'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'badge badge-light' },
	                  'Theme'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-theme' },
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/themes/ethical.jpg'), className: 'card-img-top', alt: 'Ethical theme image' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Ethical'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Invest where you know you are doing good (and as importantly, not doing harm). Add \u201CClimate Leaders\u201D from a broad range of global locations to your portfolio.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between align-items-center' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://www.betashares.com.au/fund/global-sustainability-leaders-etf/', className: 'cta-link', target: '_blank' },
	                  'Learn more'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'badge badge-light' },
	                  'Theme'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-theme' },
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/themes/health.jpg'), className: 'card-img-top', alt: 'Health theme image' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Health'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Invest your money towards companies keeping us well. Add biotechnology, healthcare, medical equipment and pharmaceutical companies to your portfolio.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between align-items-center' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.blackrock.com/au/individual/products/273430/ishares-global-healthcare-etf', className: 'cta-link', target: '_blank' },
	                  'Learn more'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'badge badge-light' },
	                  'Theme'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-sm-6' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card card-theme' },
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/themes/asia.jpg'), className: 'card-img-top', alt: 'Asia theme image' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-body' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'card-title' },
	                'Asia'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'card-text' },
	                'Invest towards large, established Asian companies listed in China, Hong Kong, Macau, Singapore, South Korea, and Taiwan.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-flex justify-content-between align-items-center' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://www.blackrock.com/au/individual/products/273416/ishares-asia-50-etf', className: 'cta-link', target: '_blank' },
	                  'Learn more'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'badge badge-light' },
	                  'Theme'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Themes;
	}(_react2.default.Component);
	
	exports.default = Themes;
	module.exports = exports['default'];

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aos = __webpack_require__(3);
	
	var _aos2 = _interopRequireDefault(_aos);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _Banner = __webpack_require__(18);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Themes = __webpack_require__(32);
	
	var _Themes2 = _interopRequireDefault(_Themes);
	
	var _Portfolios = __webpack_require__(31);
	
	var _Portfolios2 = _interopRequireDefault(_Portfolios);
	
	__webpack_require__(336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhyFirstStepPage = function (_React$Component) {
	  _inherits(WhyFirstStepPage, _React$Component);
	
	  function WhyFirstStepPage(props) {
	    _classCallCheck(this, WhyFirstStepPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  WhyFirstStepPage.prototype.componentDidMount = function componentDidMount() {
	    var isBrowser = typeof window !== 'undefined';
	    var AOS = isBrowser ? __webpack_require__(3) : undefined;
	    this.aos = AOS;
	    this.aos.init();
	  };
	
	  WhyFirstStepPage.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.aos.refresh();
	  };
	
	  WhyFirstStepPage.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Why FirstStep | Invest as you spend'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Smart technology continues to redefine every relationship we manage in our busy lives including how, where, why, what and when we save. And it just got smarter, safer, and easier with a savvy new platform that offers great returns, lower fees and peace of mind.' })
	      ),
	      _react2.default.createElement(_Banner2.default
	      //title="<h1 class='title secondary'>The smartest thing to do <br/> with your money</h1>"
	      , { title: 'The smartest thing to do with your money'
	        //tagline="<p class='tagline'>Smart technology and expertise working <br/>
	        //together to grow your savings.</p>"
	        , tagline: 'Smart technology and expertise working together to grow your savings.'
	
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card card-banner mx-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'card-body' },
	            _react2.default.createElement(
	              'p',
	              { className: 'card-text' },
	              'Smart technology continues to redefine every relationship we manage in our busy lives including how, where, why, what and when we save. And it just got smarter, safer, and easier with a savvy new platform that offers great returns, lower fees and peace of mind.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'card-text' },
	              'Start a very powerful and personal savings crusade today. Save better with a FirstStep investment portfolio and you will always be one step ahead.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'content-block text-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Better than your bank account'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'table table-bordered table-comparision text-left' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement('td', { scope: 'col' }),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'text-uppercase w-25', scope: 'col' },
	                      'Average Bank'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'text-uppercase w-40', scope: 'col' },
	                      'FirstStep Account'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle' },
	                      'Projected earnings'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle grey' },
	                      '0.85% variable per annum, 0% on everyday accounts'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'check secondary' },
	                          _react2.default.createElement('i', { className: 'fas fa-check-circle' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'info' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            '5.10% per annum (FirstStep Growth)'
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle' },
	                      'Fees'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle grey' },
	                      'Annual fees, ATM fees, overdraft fees, withdrawal penalties'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'check secondary' },
	                          _react2.default.createElement('i', { className: 'fas fa-check-circle' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'info' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            '$1.25 per month'
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle' },
	                      'Education and engagement'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle grey' },
	                      'No'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'check secondary' },
	                          _react2.default.createElement('i', { className: 'fas fa-check-circle' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'info' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Tips, progress updates on your saving goal'
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle' },
	                      'Professional account management'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle grey' },
	                      'No'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'check secondary' },
	                          _react2.default.createElement('i', { className: 'fas fa-check-circle' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'info' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Yes, every account is expertly managed'
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle' },
	                      'Technology'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle grey' },
	                      'Built on out of date legacy systems'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'align-middle' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'item' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'check secondary' },
	                          _react2.default.createElement('i', { className: 'fas fa-check-circle' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'info' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            'Powerful and secure technology'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'what-get', 'data-aos': 'fade-up', 'data-aos-once': true },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner-wrapper' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'text-center' },
	              'Reach your goals with impact and without complexity'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-theme.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Personalise with themes'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Invest in seismic trends that drive disproportionate growth in the economy'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-floppy.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Low minimums, low fees'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Get started in minutes without hurting the wallet. Start with as little as $1.'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-rising.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Effortlessly save like a genius'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Automatically reach your savings goal with recurring deposits and roundups'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-shield.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Securely managed'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Our team focus on managing your investments and securing your information'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-search.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Learn as you go'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Read tips, guides and lessons so you can save and invest with confidence'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'item' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'check' },
	                    _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/images/icons/icon-smartphone.svg'), alt: 'Feature icon' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info' },
	                    _react2.default.createElement(
	                      'h4',
	                      null,
	                      'Fast and enouraging support'
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      'Timely saving notifications and friendly support via in-app chat'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'section',
	          { className: 'content-block text-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12' },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Powered by industry veterans'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row align-items-center justify-content-center' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 col-sm-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'partner-tile' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'img-container' },
	                  _react2.default.createElement('img', { className: 'img-fluid', src: (0, _gatsbyLink.withPrefix)('/images/logos/industry-partners/EQT.png'), alt: 'Equity Trustees logo' })
	                ),
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'tile-title' },
	                  'Equity Trustees'
	                ),
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'tile-caption' },
	                  'Responsible Entity'
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { className: 'tile-link', href: 'http://www.eqt.com.au/', target: '_blank', rel: 'noopener', 'aria-label': 'Visit Equity Trustees website' },
	                  'Learn More'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 col-sm-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'partner-tile' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'img-container' },
	                  _react2.default.createElement('img', { className: 'img-fluid w-75', src: (0, _gatsbyLink.withPrefix)('/images/logos/industry-partners/AET.png'), alt: 'AET logo' })
	                ),
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'tile-title' },
	                  'Australian Executor Trustees'
	                ),
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'tile-caption' },
	                  'Independent Custodian'
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { className: 'tile-link', href: 'http://www.aetlimited.com.au/', target: '_blank', rel: 'noopener', 'aria-label': 'Visit AET website' },
	                  'Learn More'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 col-sm-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'partner-tile' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'img-container' },
	                  _react2.default.createElement('img', { className: 'img-fluid', src: (0, _gatsbyLink.withPrefix)('/images/logos/industry-partners/prime-financial.png'), alt: 'Prime Financial logo' })
	                ),
	                _react2.default.createElement(
	                  'h5',
	                  { className: 'tile-title' },
	                  'Prime Financial'
	                ),
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'tile-caption' },
	                  'Licensee'
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { className: 'tile-link', href: 'http://www.primefinancial.com.au/', target: '_blank', rel: 'noopener', 'aria-label': 'Visit Prime Financial website' },
	                  'Learn More'
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return WhyFirstStepPage;
	}(_react2.default.Component);
	
	exports.default = WhyFirstStepPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-why-firststep-index-js-7820a51e75a5e3a728a9.js